module.exports = __webpack_public_path__ + "img/icon3.a5dcd57a.png";